import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestRoutes } from '../_config/rest-routes.config';
import { HistoricStatesModule } from '../_models/historic-states.model';
import { AttachedFilesModule } from '../_models/attached-files-module.model';
import { environment } from '../../environments/environment';
import { AttachedFiles } from '../_models/attached-files.model';





@Injectable({
  providedIn: 'root'
})
export class AttachedFilesService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-type': 'application/json'
      }
    )
  };

  constructor(private http: HttpClient) { }


  AttachedFiles_GetByClaim(claimid:any): Observable<AttachedFilesModule[]> {
    let url: string = `${environment.urlWS}${RestRoutes.ATTACHED_FILES_GETBYCLAIM.replace('{CLAIMID}',claimid)}`;
    // console.log(url)
    return this.http.get<AttachedFilesModule[]>(url, this.httpOptions);
  }

  AttachedFiles_GetBase64(attachedFileID:any): Observable<AttachedFiles> {
    let url: string = `${environment.urlWS}${RestRoutes.ATTACHED_FILES}${attachedFileID}/download`;
    return this.http.get<AttachedFiles>(url, this.httpOptions);
  }
}
